import React from "react";
import "./App.css";

function App() {
  return (
    <div className="text">
      <h1>CSS EFFECT</h1>
    </div>
  );
}

export default App;
